/** @jsx jsx */
import { jsx } from '@emotion/react';

import { RatingStat } from '@coursera/cds-core';

import SiteMiscExperiments from 'bundles/epic/clients/siteMisc';

type Props = { avgProductRating?: number; numProductRatings?: number };

const ProductCardReviews = ({ avgProductRating, numProductRatings }: Props) => {
  if (!avgProductRating || (numProductRatings && numProductRatings <= 5)) {
    return null;
  }

  const rating = Math.round(avgProductRating * 10) / 10;
  const experimentVariant = SiteMiscExperiments.preview('productCardTest1');
  const size = experimentVariant === 'test1' ? 'meta' : 'label';

  return <RatingStat rating={rating} size={size} reviews={numProductRatings} />;
};

export default ProductCardReviews;
